
import { Vue, Component, Prop } from 'vue-property-decorator';
import { refreshStaticResource } from '@/service';
import { tokenClear, tokenParse, userAgent } from '@/assets/ts/util';

@Component({
    name: 'HelperBox',
    components: {},
})
export default class HelperBox extends Vue {
    @Prop({
        type: Boolean,
        default: false,
    })
    private tiny!: boolean;

    @Prop({
        type: Boolean,
        default: true,
    })
    private allowFix!: boolean;

    private $message!: any;

    public fixMe(): void {
        tokenClear();
        refreshStaticResource().then(() => {
            this.$message('已修复');
            location.href = location.href;
        }).catch((err: any) => {
            this.$message('修复出错，请联系客服' + err);
        });
    }

    public service(e: any): void {
        if (userAgent() === 'AlipayMiniProgram') {
            this.$message('请使用微信打开');
            return;
        }

        const userInfo = tokenParse();
        let url = window.Tencent.SDK_URL;
        if (userInfo && userInfo.unionid) {
            url += `&uid=${userInfo.unionid}`;
        }
        if (!url) {
            this.$message('在线客服地址丢失');
            return;
        }
        location.href = url;
    }
}
